/* eslint-disable prefer-arrow-functions/prefer-arrow-functions */
import { Observable } from 'rxjs';
import { finalize } from 'rxjs/operators';

export function isLoading<T>(stateChanged: (state: boolean) => void) {
  return function wrapOperatorFunction(source: Observable<T>): Observable<T> {
    stateChanged(true);
    return source.pipe(finalize(() => stateChanged(false)));
  };
}
